import TermsConditionsRu from 'components/termsConditions/termsConditionsRu';
import TermsConditionsEn from 'components/termsConditions/termsConditionsEn';
import TermsConditionsAz from 'components/termsConditions/termsConditionsAz';
import { ELanguageCode } from 'enums';

import useTranslation from '../../customHooks/translate';
import CustomDialog from './CustomDialog';

const TermsConditionsForm = (props) => {
  const { open, toggleModal } = props;

  const translation = useTranslation();
  const language = (localStorage.getItem('language') || 'en').replace(
    /['"]/g,
    ''
  );

  const tabs = {
    [ELanguageCode.AZ]: {
      component: <TermsConditionsAz />,
    },
    [ELanguageCode.EN]: {
      component: <TermsConditionsEn />,
    },
    [ELanguageCode.RU]: {
      component: <TermsConditionsRu />,
    },
  };

  return (
    <CustomDialog
      open={open}
      handleClose={toggleModal}
      title={translation.termsConditions.title}
      buttonTitle=""
      onSubmit={() => {}}
      hasOwnButton
    >
      <div>{tabs[language].component}</div>
    </CustomDialog>
  );
};

export default TermsConditionsForm;
